import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { class: "dialog-footer" }

import { useRouter } from 'vue-router'
import { reactive, ref, getCurrentInstance, onMounted } from 'vue'
import Pagination from '@/components/Pagination'
import { getCityListApi } from '@/apis/others'
import {
    getHomeRecommendListApi,
    addHomeRecommendApi,
    deleteHomeRecommendApi,
    HomeRecommendRunkApi
} from '@/apis/phase-one'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeRecommend',
  setup(__props) {

const router = useRouter()
const { proxy } = getCurrentInstance() as any

// 城市列表
const cityList = ref([])

// 筛选条件
const filters = reactive({
    page: 1,
    page_size: 10
})

// 搜索表单
const searchForm = reactive({
    city_id: '0',
    title: '',
    productIds: '',
    product_id: '',
    deleted: '2'
})

// 表格数据
const tableData = ref([])
const count = ref(0)
const isLoading = ref(false)

// 弹窗相关
const dialogVisible = ref(false)
const sortDialogVisible = ref(false)

// 添加商品表单
const addForm = reactive({
    productIds: ''
})

// 排序表单
const sortForm = reactive({
    productId: '',
    productName: '',
    sort_num: 0,
    id: ''
})

// 获取列表数据
const getList = () => {
    isLoading.value = true
    getHomeRecommendListApi({
        page: filters.page,
        page_size: filters.page_size,
        ...searchForm
    }).then((res: any) => {
        isLoading.value = false
        if (res.code == 200) {
            tableData.value = res.data.data || []
            count.value = res.data.total || 0
        } else {
            proxy.$message({ type: 'error', message: res.msg || '获取数据失败' })
        }
    })
}

// 获取城市列表
const getCityList = () => {
    getCityListApi().then((res: any) => {
        if (res.code == 200) {
            cityList.value = res.data || []
        } else {
            proxy.$message({ type: 'error', message: res.msg || '获取城市列表失败' })
        }
    }).catch((error: any) => {
        proxy.$message({ type: 'error', message: '获取城市列表失败' })
    })
}

// 分页处理
const handleSizeChange = (val: number) => {
    filters.page_size = val
    getList()
}

const handleCurrentChange = (val: number) => {
    filters.page = val
    getList()
}


// 查看商品
const handleViewProduct = (row: any) => {
    router.push(`/merchant-admin/product-edit?id=${row.product_id}&source=1&t=view&o=1`)
}

// 搜索
const handleSearch = () => {
    filters.page = 1
    getList()
}

// 打开添加商品弹窗
const handleAdd = () => {
    if (searchForm.productIds) {
        addForm.productIds = searchForm.productIds
    }
    dialogVisible.value = true
}

// 处理添加商品
const handleAddProduct = () => {
    if (!addForm.productIds) {
        proxy.$message({ type: 'warning', message: '请输入商品ID' })
        return
    }
    
    const productIdList = addForm.productIds.split(',').map(id => id.trim()).filter(id => id)
    if (productIdList.length === 0) {
        proxy.$message({ type: 'warning', message: '请输入有效的商品ID' })
        return
    }
    isLoading.value = true
    addHomeRecommendApi({ product_id: productIdList.join(','), city_ids: searchForm.city_id || ''  })
        .then((res: any) => {
            isLoading.value = false
            if (res.code == 200) {
                proxy.$message({ type: 'success', message: `成功添加 ${productIdList.length} 个商品` })
                dialogVisible.value = false
                addForm.productIds = ''
                searchForm.productIds = ''
                getList()
            } else {
                proxy.$message({ type: 'error', message: res.msg || '添加商品失败' })
            }
        })
}

// 处理修改排序值
const handleSort = (row: any) => {
    sortForm.id = row.id || ''
    sortForm.productId = row.product_id || ''
    sortForm.productName = row.title || ''
    sortForm.sort_num = row.sort_num || ''
    sortDialogVisible.value = true
}

// 保存排序值
const handleSaveSort = () => {
    isLoading.value = true
    HomeRecommendRunkApi({
        id: sortForm.id,
        sort_num: sortForm.sort_num
    })
        .then((res: any) => {
            isLoading.value = false
            if (res.code == 200) {
                proxy.$message({ type: 'success', message: '排序值修改成功' })
                sortDialogVisible.value = false
                getList()
            } else {
                proxy.$message({ type: 'error', message: res.msg || '排序值修改失败' })
            }
        })
}
const handleDialogClose = () => {
    dialogVisible.value = false
    addForm.productIds = ''
}

// 处理删除
const handleDelete = (row: any) => {
    proxy.$confirm(
        `确定要删除商品「${row.title}」吗？`,
        '删除确认',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }
    ).then(() => {
        isLoading.value = true
        deleteHomeRecommendApi({
            id: row.id
        })
            .then((res: any) => {
                isLoading.value = false
                if (res.code == 200) {
                    proxy.$message({ type: 'success', message: '商品删除成功' })
                    getList()
                } else {
                    proxy.$message({ type: 'error', message: res.msg || '商品删除失败' })
                }
            })
    })
}

// 初始化数据
onMounted(() => {
    getList()
    getCityList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        modelValue: searchForm.city_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.city_id) = $event)),
        placeholder: "全国",
        style: {"width":"200px"},
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全国",
            value: "0"
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (city) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: city.id,
              label: city.name,
              value: city.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: searchForm.product_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.product_id) = $event)),
        placeholder: "请输入商品ID",
        style: {"width":"200px","margin-left":"10px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: searchForm.title,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.title) = $event)),
        placeholder: "请输入商品名称",
        style: {"width":"200px","margin-left":"10px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: searchForm.deleted,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.deleted) = $event)),
        placeholder: "请选择商品状态",
        style: {"width":"200px","margin-left":"10px"},
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "上架",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "下架",
            value: "1"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSearch,
        style: {"margin-left":"10px"}
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleAdd,
        style: {"margin-left":"10px"}
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("添加")
        ])),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          width: "60"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_id",
          label: "品牌ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "product_id",
          label: "商品ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "商品"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sort_num",
          label: "排序值",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "当前商品状态",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.deleted == 0 ? '上架' : '下架'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "260"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (handleViewProduct(scope.row))
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (handleSort(scope.row))
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("修改排序值")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (handleDelete(scope.row))
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("删除")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, isLoading.value]
    ]),
    _createVNode(_unref(Pagination), {
      currentPage: filters.page,
      total: count.value,
      onPageChange: handleCurrentChange,
      onSizeChange: handleSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event)),
      title: "添加商品",
      width: "500px",
      onClose: handleDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, { onClick: handleDialogClose }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleAddProduct
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("确定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": "left",
          "label-width": "140px",
          model: addForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商品ID（逗号分隔）" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addForm.productIds,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addForm.productIds) = $event)),
                  placeholder: "输入商品id，多个id请用逗号分隔",
                  type: "textarea",
                  rows: 3
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: sortDialogVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((sortDialogVisible).value = $event)),
      title: "修改排序值",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (sortDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSaveSort
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("保存")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": "left",
          "label-width": "120px",
          model: sortForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商品名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: sortForm.productName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((sortForm.productName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "商品ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: sortForm.productId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((sortForm.productId) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "排序值" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: sortForm.sort_num,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((sortForm.sort_num) = $event)),
                  min: 0,
                  step: 1,
                  placeholder: "请输入排序值"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})